import { React, useRef } from 'react'
import { useReactToPrint } from 'react-to-print';

import "./Review.scss";
import { Icon } from "@iconify/react";

const ReviewReport = ({ ourBrand }) => {
  const reportRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => reportRef.current,
  });

  const getPageMarginsF = () => {
    return `@page :first { margin: ${"0px"} ${"0px"} ${"10px"} ${"0px"} !important; }`;
  };
  const getPageMargins = () => {
    return `@page { margin: ${"30px"} ${"30px"} ${"30px"} ${"30px"} !important; }`;
  };
  const getPageMarginss = () => {
    return `@print { .removeDuringPrint{ display: none;} }`;
  };
  const getPageMarginst = () => {
    return `.strenth-card { page-break-inside: avoid; }`;
  };
  return (
    <>
      <button style={{ backgroundColor: "#93393C", color: "white", marginLeft: "20px", borderRadius: "5px", padding: "5px", fontSize: "16px" }} onClick={handlePrint}>Save PDF</button>
      <style>{getPageMarginst()}</style>
      <style>{getPageMargins()}</style>
      <div className="customScroller-transparent">
        <div ref={reportRef} >
          <div className="Summary-container">
            <h3>Summary</h3>
            <div class="Summary-box">
              <p>{ourBrand && ourBrand.analysis ? ourBrand.analysis.summary : "Summary"}</p>
            </div>
          </div>


          <div className="Strenths-container">
            <h3>Sentiment Analysis</h3>
            <div className="Strenths-cards-container">
              <div className="strenth-card">
                <h3>Why Positive</h3>
                <ul>
                  {ourBrand && ourBrand.analysis && ourBrand.analysis.whyPositiveReviews
                    ? ourBrand.analysis.whyPositiveReviews
                      .map(
                        (positiveReview) => (
                          <>
                            <h5>{positiveReview.heading}</h5>
                            <li>
                              <Icon
                                icon="solar:map-arrow-right-bold-duotone"
                                width="20"
                                height="20"
                              />
                              {positiveReview.reasons}
                            </li>
                          </>
                        )
                      )
                    : (
                      <li>
                        <Icon
                          icon="solar:map-arrow-right-bold-duotone"
                          width="20"
                          height="20"
                        />
                        Innovative problem-solving approach.
                      </li>
                    )}
                  {/* <li>
                    <Icon
                      icon="solar:map-arrow-right-bold-duotone"
                      width="20"
                      height="20"
                    />
                    Innovative problem-solving approach.
                  </li>
                  <li>
                    <Icon
                      icon="solar:map-arrow-right-bold-duotone"
                      width="20"
                      height="20"
                    />
                    Adaptable to diverse tasks.
                  </li>
                  <li>
                    <Icon
                      icon="solar:map-arrow-right-bold-duotone"
                      width="20"
                      height="20"
                    />
                    Detail-oriented and accurate.
                  </li>
                  <li>
                    <Icon
                      icon="solar:map-arrow-right-bold-duotone"
                      width="20"
                      height="20"
                    />
                    Effective team player.
                  </li>

                  <li>
                    <Icon
                      icon="solar:map-arrow-right-bold-duotone"
                      width="20"
                      height="20"
                    />
                    Endures challenges with fortitude.
                  </li> */}
                </ul>
              </div>

              <div className="strenth-card">
                <h3>Why Neutral</h3>
                <ul>
                  {ourBrand && ourBrand.analysis && ourBrand.analysis.whyNeutralReviews

                    ? ourBrand.analysis.whyNeutralReviews

                      .map(
                        (neutralReview) => (
                          <>
                            <h5>{neutralReview.heading}</h5>
                            <li>
                              <Icon
                                icon="solar:map-arrow-right-bold-duotone"
                                width="20"
                                height="20"
                              />
                              {neutralReview.reasons}
                            </li>
                          </>
                        )
                      )
                    : (
                      <li>
                        <Icon
                          icon="solar:map-arrow-right-bold-duotone"
                          width="20"
                          height="20"
                        />
                        Innovative problem-solving approach.
                      </li>
                    )}
                  {/* <li>
                    <Icon
                      icon="solar:map-arrow-right-bold-duotone"
                      width="20"
                      height="20"
                    />
                    Innovative problem-solving approach.
                  </li>
                  <li>
                    <Icon
                      icon="solar:map-arrow-right-bold-duotone"
                      width="20"
                      height="20"
                    />
                    Adaptable to diverse tasks.
                  </li>
                  <li>
                    <Icon
                      icon="solar:map-arrow-right-bold-duotone"
                      width="20"
                      height="20"
                    />
                    Detail-oriented and accurate.
                  </li>
                  <li>
                    <Icon
                      icon="solar:map-arrow-right-bold-duotone"
                      width="20"
                      height="20"
                    />
                    Effective team player.
                  </li>

                  <li>
                    <Icon
                      icon="solar:map-arrow-right-bold-duotone"
                      width="20"
                      height="20"
                    />
                    Endures challenges with fortitude.
                  </li> */}
                </ul>
              </div>
              <div className="strenth-card">
                <h3>Why Negative</h3>
                <ul>
                  {ourBrand && ourBrand.analysis && ourBrand.analysis.whyNegativeReviews

                    ? ourBrand.analysis.whyNegativeReviews

                      .map(
                        (negativeReview) => (
                          <>
                            <h5>{negativeReview.heading}</h5>
                            <li>
                              <Icon
                                icon="solar:map-arrow-right-bold-duotone"
                                width="20"
                                height="20"
                              />
                              {negativeReview.reasons}
                            </li>
                          </>
                        )
                      )
                    : (
                      <li>
                        <Icon
                          icon="solar:map-arrow-right-bold-duotone"
                          width="20"
                          height="20"
                        />
                        Innovative problem-solving approach.
                      </li>
                    )}
                  {/* <li>
                    <Icon
                      icon="solar:map-arrow-right-bold-duotone"
                      width="20"
                      height="20"
                    />
                    Innovative problem-solving approach.
                  </li>
                  <li>
                    <Icon
                      icon="solar:map-arrow-right-bold-duotone"
                      width="20"
                      height="20"
                    />
                    Adaptable to diverse tasks.
                  </li>
                  <li>
                    <Icon
                      icon="solar:map-arrow-right-bold-duotone"
                      width="20"
                      height="20"
                    />
                    Detail-oriented and accurate.
                  </li>
                  <li>
                    <Icon
                      icon="solar:map-arrow-right-bold-duotone"
                      width="20"
                      height="20"
                    />
                    Effective team player.
                  </li>

                  <li>
                    <Icon
                      icon="solar:map-arrow-right-bold-duotone"
                      width="20"
                      height="20"
                    />
                    Endures challenges with fortitude.
                  </li> */}
                </ul>
              </div>
            </div>
          </div>

          <div className="Strenths-container">
            <div className="Strenths-cards-container">
              <div className="strenth-card">
                <h3>Strengths</h3>
                <ul>
                  {ourBrand && ourBrand.analysis && ourBrand.analysis.strengths ? ourBrand.analysis.strengths.map(
                    (strengths) => (
                      <li>
                        <Icon
                          icon="solar:map-arrow-right-bold-duotone"
                          width="20"
                          height="20"
                        />
                        {strengths}
                      </li>
                    )
                  )
                    : (
                      <li>
                        <Icon
                          icon="solar:map-arrow-right-bold-duotone"
                          width="20"
                          height="20"
                        />
                        Innovative problem-solving approach.
                      </li>
                    )}
                  {/* <li>
                    <Icon
                      icon="solar:map-arrow-right-bold-duotone"
                      width="20"
                      height="20"
                    />
                    Innovative problem-solving approach.
                  </li>
                  <li>
                    <Icon
                      icon="solar:map-arrow-right-bold-duotone"
                      width="20"
                      height="20"
                    />
                    Adaptable to diverse tasks.
                  </li>
                  <li>
                    <Icon
                      icon="solar:map-arrow-right-bold-duotone"
                      width="20"
                      height="20"
                    />
                    Detail-oriented and accurate.
                  </li>
                  <li>
                    <Icon
                      icon="solar:map-arrow-right-bold-duotone"
                      width="20"
                      height="20"
                    />
                    Effective team player.
                  </li>

                  <li>
                    <Icon
                      icon="solar:map-arrow-right-bold-duotone"
                      width="20"
                      height="20"
                    />
                    Endures challenges with fortitude.
                  </li> */}
                </ul>
              </div>

              <div className="strenth-card">
                <h3>Weaknesses</h3>
                <ul>
                  {ourBrand && ourBrand.analysis && ourBrand.analysis.weaknesses ? ourBrand.analysis.weaknesses.map(
                    (weakness) => (
                      <li>
                        <Icon
                          icon="solar:map-arrow-right-bold-duotone"
                          width="20"
                          height="20"
                        />
                        {weakness}
                      </li>
                    )

                  ) : (
                    <li>
                      <Icon
                        icon="solar:map-arrow-right-bold-duotone"
                        width="20"
                        height="20"
                      />
                      Delays completion of tasks.
                    </li>
                  )}
                  {/* <li>
                    <Icon
                      icon="solar:map-arrow-right-bold-duotone"
                      width="20"
                      height="20"
                    />
                    Delays completion of tasks.
                  </li>
                  <li>
                    <Icon
                      icon="solar:map-arrow-right-bold-duotone"
                      width="20"
                      height="20"
                    />
                    Difficulty waiting for results.
                  </li>
                  <li>
                    <Icon
                      icon="solar:map-arrow-right-bold-duotone"
                      width="20"
                      height="20"
                    />
                    Struggles with accepting imperfections.
                  </li>
                  <li>
                    <Icon
                      icon="solar:map-arrow-right-bold-duotone"
                      width="20"
                      height="20"
                    />
                    Reluctant to assign responsibilities.
                  </li>

                  <li>
                    <Icon
                      icon="solar:map-arrow-right-bold-duotone"
                      width="20"
                      height="20"
                    />
                    Nervousness in presenting publicly.
                  </li> */}
                </ul>
              </div>

              <div className="strenth-card">
                <h3>Recommendations</h3>
                <ul>
                  {ourBrand && ourBrand.analysis && ourBrand.analysis.recommendations ? ourBrand.analysis.recommendations.map(
                    (recommendation) => (
                      <li>
                        <Icon
                          icon="solar:map-arrow-right-bold-duotone"
                          width="20"
                          height="20"
                        />
                        {recommendation}
                      </li>
                    )
                  )
                    : (
                      <li>
                        <Icon
                          icon="solar:map-arrow-right-bold-duotone"
                          width="20"
                          height="20"
                        />
                        Embrace ongoing education opportunities.
                      </li>
                    )}
                  {/* <li>
                    <Icon
                      icon="solar:map-arrow-right-bold-duotone"
                      width="20"
                      height="20"
                    />
                    Embrace ongoing education opportunities.
                  </li>
                  <li>
                    <Icon
                      icon="solar:map-arrow-right-bold-duotone"
                      width="20"
                      height="20"
                    />
                    Enhance interpersonal and written skills.
                  </li>
                  <li>
                    <Icon
                      icon="solar:map-arrow-right-bold-duotone"
                      width="20"
                      height="20"
                    />
                    Prioritize tasks for efficiency.
                  </li>
                  <li>
                    <Icon
                      icon="solar:map-arrow-right-bold-duotone"
                      width="20"
                      height="20"
                    />
                    Cultivate professional relationships strategically.
                  </li>

                  <li>
                    <Icon
                      icon="solar:map-arrow-right-bold-duotone"
                      width="20"
                      height="20"
                    />
                    Establish clear, achievable objectives.
                  </li> */}
                </ul>
              </div>
            </div>
          </div>

          <div className="Review-container removeDuringPrint">
            <h3>Reviews</h3>
            <div
              className="Review-cards-container"
              style={{ overflowX: "auto" }}
            >
              {ourBrand.review &&
                ourBrand.review.reviews &&
                ourBrand.review.reviews.map((reviews, i) => (
                  reviews.reviewText ?
                    <div className="Review-cards-box">
                      <h5>{reviews.consumerName}</h5>
                      <h6>{reviews.reviewTitle}</h6>
                      <div className="flexQuotes">
                        {/* <Icon
                        icon="ci:double-quotes-l"
                        className="qoutes-symbol1"
                      /> */}
                        <p>{reviews.reviewText}</p>
                        {/* <Icon
                        icon="ci:double-quotes-r"
                        className="qoutes-symbol2"
                      /> */}
                      </div>
                    </div>
                    :
                    ""
                ))}
              {/* <div className="Review-cards-box">
                <h5>La Lisa</h5>
                <h6>TERRIBLE customer support</h6>
                <div className="flexQuotes">
                  <Icon icon="ci:double-quotes-l" className="qoutes-symbol1" />
                  <p>
                    TERRIBLE customer support. Not even giving them every single
                    piece of proof (even your old credit card info where all the
                    purchases are attached) about a stolen account being yours makes
                    them realize it's yours and WILL allow hackers to keep stolen
                    accounts by not checking any proof. Now, they will gladly ban
                    you by IP yet they cannot check the IP when it comes to
                    thievery. If I were you, I would just limit myself to Steam.
                  </p>
                  <Icon icon="ci:double-quotes-r" className="qoutes-symbol2" />
                </div>
              </div>
              <div className="Review-cards-box">
                <h5>Devil Jennie</h5>
                <h6>TERRIBLE customer support</h6>
                <div className="flexQuotes">
                  <Icon icon="ci:double-quotes-l" className="qoutes-symbol1" />
                  <p>
                    TERRIBLE customer support. Not even giving them every single
                    piece of proof (even your old credit card info where all the
                    purchases are attached) about a stolen account being yours makes
                    them realize it's yours and WILL allow hackers to keep stolen
                    accounts by not checking any proof. Now, they will gladly ban
                    you by IP yet they cannot check the IP when it comes to
                    thievery. If I were you, I would just limit myself to Steam.
                  </p>
                  <Icon icon="ci:double-quotes-r" className="qoutes-symbol2" />
                </div>
              </div>
              <div className="Review-cards-box">
                <h5>Devil Jennie</h5>
                <h6>TERRIBLE customer support</h6>
                <div className="flexQuotes">
                  <Icon icon="ci:double-quotes-l" className="qoutes-symbol1" />
                  <p>
                    TERRIBLE customer support. Not even giving them every single
                    piece of proof (even your old credit card info where all the
                    purchases are attached) about a stolen account being yours makes
                    them realize it's yours and WILL allow hackers to keep stolen
                    accounts by not checking any proof. Now, they will gladly ban
                    you by IP yet they cannot check the IP when it comes to
                    thievery. If I were you, I would just limit myself to Steam.
                  </p>
                  <Icon icon="ci:double-quotes-r" className="qoutes-symbol2" />
                </div>
              </div> */}
            </div>
          </div>



        </div>
      </div >
    </>
  )
}

export default ReviewReport